<template>
  <div class="Reserve">
    <div class="head-sub">
      <span class="sub">已预约</span>
      <span class="cord" @click="go('/reserveRecord')">
        <i>预约记录</i>
        <van-icon name="arrow" />
      </span>
    </div>
    <van-list
      v-model="dataList.loading"
      :finished="dataList.finished"
      finished-text="没有更多了"
      @load="getData"
    >
      <van-cell class="no-border-cell mb15" v-for="v in dataList.list" :key="v.id">
        <div class="record-list">
          <div class="list-item">
            <div class="left">
              <p>
                <span class="item-tit">服务项目:</span>
                <span class="item-user">{{v.serviceName}}</span>
              </p>
              <p>
                <span class="item-tit">预约时间:</span>
                <span class="item-user">
                  {{
                  dateFormat(
                  toTimeStamp(v.startTime),
                  "yyyy年MM月dd日 hh:mm"
                  ) +
                  " - " +
                  dateFormat(toTimeStamp(v.endTime), "hh:mm")
                  }}
                </span>
              </p>
              <p>
                <span class="item-tit">预约门店:</span>
                <span class="item-user">{{v.shopName}}</span>
              </p>
            </div>
            <div :class="v.status===1?'right active':'right'">
              <span>{{v.status|reserveStatusFilter}}</span>
            </div>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
export default {
  name: "Reserve",
  data() {
    return {
      dataList: {
        current: 1,
        size: 10,
        list: [],
        finished: false,
        loading: false // 异步加载状态
      }
    };
  },
  filters: {},
  mounted() {},
  methods: {
    // 已预约
    async getData() {
      let param = {
        current: this.dataList.current,
        size: this.dataList.size,
        status: "0"
      };
      try {
        let res = await this.request("/user/userAppointment/myList", {
          ...param
        });
        if (this.dataList.current === 1) this.dataList.list = res.List;
        else this.dataList.list = [...this.dataList.list, ...res.List];
        this.$nextTick(() => {
          if (res.List.length < res.TotalCount) {
            this.dataList.current++;
          }
          this.dataList.loading = false;
          // 数据全部加载完成
          if (this.dataList.list.length >= res.TotalCount) {
            this.dataList.finished = true;
          }
        });
        console.log(res);
      } catch (e) {
        this.dataList.loading = false;
        this.dataList.finished = true;
        this.$error(e.message);
      }
    },
    // 领取
    getRecive() {
      this.step = 2;
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.Reserve {
  height: 100vh;
  overflow: auto;
  background: #f7f7f7;
  padding: @pad;
  .head-sub {
    .fj();
    align-items: center;
    padding: @pad 0;
    .sub {
      .sc(15px, @baseColor);
      font-weight: bold;
    }
    .cord {
      .flex-center();
      i {
        font-style: normal;
        .sc(12px, #333);
      }
    }
  }
  .mb15 {
    margin-bottom: 10px;
  }
  .record-list {
    .list-item {
      background: #fff;
      // padding: 15px 0 15px 10px;
      font-size: 14px;
      // margin-bottom: 15px;
      border-radius: 3px;
      .fj(@type:space-between);
      p {
        line-height: 35px;
        color: #333;
        .item-tit {
          padding-right: 5px;
        }
      }
      .right {
        color: #979797;
        &.active {
          color: @baseColor;
        }
      }
    }
  }
}
</style>